import { Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { RequestDownloadExcelDto } from "../../shared/nestjs/gd-only/dto/attendance-report.dto";
import { AttendanceLocationReportApi } from "../../shared/nestjs/gd-only/services/attendance-location-report.api";

@Injectable()
export class AttendanceLocationReportBloc {

  constructor(
    private fileDownloaderProvider: FileDownloaderProvider,
    private platform: Platform,
    private attendanceLocationReportApi: AttendanceLocationReportApi,
    private analyticsProvider: AnalyticsProvider,
  ) {

  }

  downloadExcel(data: RequestDownloadExcelDto): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
    return this.attendanceLocationReportApi.downloadExcel(data)
  }

  generateExcel(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadExcelBlob(data, 'Attendance Location Report')
    } else {
      saveAs(data, 'Attendance Location Report.xlsx')
    }
  }

  downloadPdf(data): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
    return this.attendanceLocationReportApi.downloadPdf(data)
  }

  generatePdf(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, 'Attendance Location Report')
    } else {
      saveAs(data, 'Attendance Location Report.pdf')
    }
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/attendance-location-report.bloc.ts